<template>
  <div class="DemandWriteSuccessDialog">
    <CgModalMiddle
      @close="close"
    >
      <div slot="modal_content" class="modal-content">
        111111
      </div>
    </CgModalMiddle>
  </div>
</template>

<script>
export default {
  name: "DemandWriteSuccessDialog"
}
</script>

<style scoped>

</style>
